module.exports = __webpack_public_path__ + "img/daichao1.45917d0a.png";